module.exports = __webpack_public_path__ + "static/media/proj20_img16.ed8c21d1.jpg";